export const formations = [
  {
    slug: 'wordpress',
    title: 'Formation WordPress',
    formationLink: 'https://eliteummah.systeme.io/paiement-wordpress',
    formationInstallmentLink: 'https://eliteummah.systeme.io/paiement-wordpress-4x',
    installmentLabel: 'Payer en 5x',
    shortDescription: 'Créez des sites web professionnels avec WordPress, sans coder',
    longDescription:
      'Apprenez à concevoir, personnaliser et mettre en ligne des sites web professionnels avec WordPress. De l’installation à la mise en production, maîtrisez l’outil le plus utilisé au monde pour créer des sites, sans écrire une ligne de code.',
    price: '250€',
    level: 'Débutant à intermédiaire',
    goals: [
      'Installer et configurer WordPress de A à Z',
      'Concevoir un site professionnel et responsive sans coder',
      'Maîtriser les thèmes, les extensions et les constructeurs de pages',
      'Optimiser la vitesse, le référencement et la sécurité de votre site',
      'Mettre votre site en ligne et en assurer la maintenance',
      'Proposer la création de sites comme service facturable à des clients'
    ],
    program: [
      ' Prise en main de WordPress : hébergement, installation et tableau de bord',
      ' Thèmes et personnalisation : choisir et adapter le design à votre projet',
      ' Constructeur de pages : créer des pages sur-mesure en glisser-déposer',
      ' Extensions essentielles : SEO, formulaires, sécurité et performance',
      ' Gestion du contenu : pages, articles, menus et médias',
      ' Mise en ligne : nom de domaine, hébergement et passage en production',
      ' Maintenance et sauvegardes : garder un site sûr et à jour',
      ' Vendre vos sites : trouver des clients et facturer vos prestations'
    ]
  },
  {
    slug: 'seo',
    title: 'Formation SEO',
    formationLink: 'https://eliteummah.systeme.io/paiement-seo',
    formationInstallmentLink: 'https://eliteummah.systeme.io/paiement-seo-4x',
    shortDescription: 'Générez du trafic qualifié avec une stratégie SEO durable',
    longDescription:
      'Maîtrisez les fondamentaux du référencement naturel pour améliorer votre visibilité sur Google et attirer un trafic régulier.',
    oldPrice: '499€',
    price: '399€ avec le code "BOURGET26"',
    level: 'Intermédiaire',
    goals: [
      'Comprendre les critères de classement des moteurs de recherche',
      'Trouver les mots-clés pertinents selon votre audience',
      'Optimiser vos pages pour améliorer leur positionnement',
      'Construire une stratégie SEO long terme mesurable'
    ],
    program: [
      ' Fondamentaux SEO et audit de départ',
      ' Recherche de mots-clés et architecture du contenu',
      ' SEO on-page et optimisation technique',
      ' Rédaction SEO et optimisation éditoriale',
      ' Maillage interne et autorité thématique',
      ' Netlinking et signaux de confiance',
      ' Analyse des performances et itérations',
      'service-icon Plan d\'action long terme'
    ]
  }
];

export const getFormationBySlug = (slug) =>
  formations.find((formation) => formation.slug === slug);
